export const layoutUk: Record<string, string> = {
  "nav.logoAria": "IT-24.pro на головну",
  "nav.devops": "Послуги",
  "nav.admin": "Аудит",
  "nav.support": "Невідкладна допомога",
  "nav.vps": "Контакти",
  "nav.k8s": "Проєкти",
  "nav.cicd": "Кейси",
  "nav.ddos": "Про мене",
  "nav.llmops": "Retainer",
  "nav.packages": "Послуги",
  "nav.audience": "Для кого",
  "nav.cases": "Кейси",
  "nav.portfolio": "Кейси",
  "nav.contacts": "Контакти",
  "nav.auditCta": "Написати в Telegram",
  "nav.auditCtaShort": "Telegram",
  "nav.ariaMain": "Основна навігація",
  "nav.langSwitcherAria": "Мова сайту",
  "nav.menuOpen": "Відкрити меню навігації",
  "nav.menuClose": "Закрити меню навігації",
  "nav.langRu": "RU",
  "nav.langUk": "UA",
  "nav.langKk": "KZ",
  "nav.langUz": "UZ",
  "nav.langKy": "KG",

  "footer.tagline":
    "Інфраструктура для криптовалютного сектору, фінтеху та highload. Юридична особа PL · Telegram.",
  "footer.badge1": "✓ PCI / DDoS / K8s",
  "footer.badge2": "✓ USDT / інвойс",
  "footer.badge3": "✓ З 2010 в інфраструктурі",
  "footer.consultCta": "Написати в Telegram",
  "footer.servicesTitle": "Послуги",
  "footer.tariffsHome": "Послуги на головній",
  "footer.devops": "DevOps retainer",
  "footer.serverSupport": "Невідкладна допомога",
  "footer.serverAdmin": "Аудит",
  "footer.k8s": "Проєкти PCI / DDoS / K8s",
  "footer.cicd": "Кейси",
  "footer.ddos": "Про мене",
  "footer.llmops": "Контакти",
  "footer.vps": "nexops.eu (EU)",
  "footer.vacancies": "Telegram",
  "footer.contactTitle": "Контакти",
  "footer.location": "Konin, Poland",
  "footer.copy": "Усі права захищені.",
  "footer.taglineBottom": "Криптовалютний сектор · фінтех · highload · Telegram",

  "cookie.title": "Ми використовуємо файли cookie для кращого досвіду",
  "cookie.body":
    "Ми використовуємо cookie, щоб вам було зручніше користуватися сайтом і щоб працювали окремі функції. Продовжуючи відвідування, ви погоджуєтесь на використання cookie.",
  "cookie.reject": "Відхилити",
  "cookie.accept": "Прийняти",

  "notFound.title": "Сторінку не знайдено | IT-24.pro",
  "notFound.description":
    "Такої сторінки немає. Інфраструктура для криптовалютного сектору та фінтеху — на головній.",
  "notFound.h1": "Сторінку не знайдено",
  "notFound.text":
    "Можливо, посилання застаріло — старі послуги перенесено до нових розділів.",
  "notFound.home": "На головну",
  "notFound.devops": "Retainer / послуги",

  "breadcrumb.home": "Головна",
  "breadcrumb.devopsServices": "Послуги",
  "breadcrumb.ariaLabel": "Навігаційний ланцюжок",

  "search.title": "Пошук по сайту | IT-24.pro",
  "search.titleWithQuery": "Пошук: {query} | IT-24.pro",
  "search.description": "Пошук послуг: retainer, аудит, PCI, DDoS, Kubernetes на IT-24.pro.",
  "search.h1": "Пошук по сайту",
  "search.lead": "Знайдіть послугу: невідкладна допомога, аудит, retainer, проєкти.",
  "search.placeholder": "Наприклад: pci, ddos, retainer",
  "search.submit": "Знайти",
  "search.prompt": "Введіть запит — покажемо відповідні розділи сайту.",
  "search.resultsCount": "Знайдено: {count}",
  "search.noResults": "За запитом «{query}» нічого не знайдено.",
  "search.emptyHint": "Спробуйте інші ключові слова або перейдіть до послуг.",
};
